/* GeneratedContentHash: c6b09ab44a8cfceef054a2af43aa5daeb8a11e0e976cb9dfd6741ed3d1547a75 */
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/

import { asMessageRenderer } from '@post-office/placement-common';
import growth from '@post-office/team-export--growth/placements/in-app/confluence-home-banner/render';
import postOfficeTemplate from '@post-office/team-export--post-office-template/placements/in-app/confluence-home-banner/render';
import testMessages from '@post-office/team-export--test-messages/placements/in-app/confluence-home-banner/render';

export const renderer = { ...growth, ...postOfficeTemplate, ...testMessages };

//TODO: add validator as second arguement to asMessageRenderer when validators are ready
//import { validator } from './validate';

export const { initializeMessageRenderer, MessageRenderer } = asMessageRenderer(renderer);
